module.exports = __webpack_public_path__ + "files/8c3df70396bcffc9c6f7aa7f8bdf22e4.png";